//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import ListedSingleCoin from '~/components/detail/listed_single_coin'
export default {
  name: 'SuggestedCoins',
  components: { ListedSingleCoin },
  data () {
    return {
      selectedCoinType: this.$var.popular,
      coinTypes: [this.$var.popular, this.$var.new]
    }
  },
  computed: {
    ...mapGetters({
      trends: 'coins/trends',
      latest: 'coins/latest'
    }),
    wantedCoins () {
      if (this.selectedCoinType === this.$var.popular) {
        return this.trends.slice(0, 5)
      } else if (this.selectedCoinType === this.$var.new) {
        return this.latest.slice(0, 5)
      }
      return []
    }
  }
}
